
Greenmile.Geocoding = Greenmile.Geocoding || {};

Greenmile.Geocoding = function() {

    return function (map) {

        this.getAddress = (searchSelector) => {

            var addressField = document.querySelectorAll(searchSelector);

            if (addressField.length > 0) {
                return addressField[0].value;
            }

            return false;

        };

        this.getGeocoder = () => {
            let configs = Greenmile.Map.Utility.getMapProviderConfigs();
            var gGeocode = null;
            if (configs.bing && configs.bing.configs.clientKey) {
                gGeocode = new Greenmile.Geocoding.Bing(map, configs.bing.configs.clientKey);
            } else {
                gGeocode = new Greenmile.Geocoding.Google();
            }

            return gGeocode;
        };

        this.geocode = (searchSelector, sucessCallback, errorCallback) => {

            var addresToGeocode = this.getAddress(searchSelector);

            if (addresToGeocode) {

                this.getGeocoder().geocode(addresToGeocode, sucessCallback, errorCallback);

            } else {
                return "no address found";
            }
        };

    };
}();